"use client"

import { useClientTranslation } from "@/modules/App/components/i18n/i18n.client"
import { FR_APP_DOWNLOAD_URL } from "@/shared/utils/links"
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTextContainer,
  DialogTitle,
  DialogTrigger,
} from "@dalmatech/ui"
import Image from "next/image"

import * as styles from "./navbar.styled"

const pillClass =
  "flex h-10 items-center rounded-full bg-neutral-100 px-4 text-sm font-bold tracking-tight text-neutral-700 font-buenosAires "

const WelcomeDownloadAppButton = () => {
  const { t } = useClientTranslation("welcome-page", { keyPrefix: "welcome-section.app-card" })

  return (
    <>
      {/* Mobile: direct link */}
      <a
        href={FR_APP_DOWNLOAD_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`${pillClass} font-buenosAires md:hidden`}
      >
        {t("title")}
      </a>
      {/* Desktop: QR dialog */}
      <Dialog>
        <DialogTrigger asChild>
          <button className={`${pillClass} hidden cursor-pointer md:flex`}>{t("title")}</button>
        </DialogTrigger>
        <DialogContent className="max-w-[27rem]">
          <div className="flex justify-center pt-2">
            <Image
              src="/img/illus/49mk01sk_qr_code.svg"
              alt="QR code"
              width={128}
              height={128}
              draggable={false}
            />
          </div>
          <DialogTextContainer>
            <DialogTitle>{t("modal-title")}</DialogTitle>
            <DialogDescription>{t("modal-description")}</DialogDescription>
          </DialogTextContainer>
          <DialogFooter>
            <DialogClose asChild>
              <Button size="lg">{t("modal-cta")}</Button>
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}

export const WelcomeNavbar = () => {
  return (
    <div className={styles.rootAlwaysBordered}>
      <div className={styles.welcomeNavbar}>
        <a href="https://www.dalma.co" className={styles.logoLink} title="dalma.co">
          <Image src="/img/dalma-logo.svg" width={64} height={20} alt="Dalma" />
        </a>
        <WelcomeDownloadAppButton />
      </div>
    </div>
  )
}
